const m = {
    name: "common",
    dependencyInfo: {},
    dependencies: [],
    src: `module common

const TOKEN_NAME_PROTOCOL_PARAMS: ByteArray = #70726f746f636f6c2d706172616d73 // protocol-params
const TOKEN_NAME_AUTH: ByteArray = #61757468 // auth

struct DatumProtocolParams {
  mod_pkh: PubKeyHash
  treasury_address: Address
  kreator_mint_fee: Int // lovelace per edition
}

struct DatumArtwork {
  owner_address: Address
  collection_id: ByteArray // collection id in MongoDB
  token_name: ByteArray // artwork id in MongoDB
  mint_fee: Int // lovelace per edition
  num_editions: Int
  num_minted: Int
}
`
}

export { m as default }
